import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../core/auth.service';

@Component({
  selector: 'app-auth-callback',
  imports: [CommonModule, RouterLink],
  templateUrl: './auth-callback.html'
})
export class AuthCallback implements OnInit {
  error = '';

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    const params = new URLSearchParams(window.location.search);
    const oauthError = params.get('error');
    const oauthErrorDescription = params.get('error_description');
    const code = params.get('code');
    const state = params.get('state');

    if (oauthError) {
      this.error = this.describeOAuthError(oauthError, oauthErrorDescription);
      return;
    }

    if (!code || !state) {
      this.error = 'Cognito no devolvio codigo de autorizacion.';
      return;
    }

    try {
      await this.auth.handleCallback(code, state);
      await this.router.navigateByUrl('/dashboard');
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        this.error = 'Cognito no respondio al intercambio de token. Si el App Client tiene client secret, Angular no puede completar este paso directamente.';
        return;
      }

      this.error = error instanceof Error ? error.message : 'No se pudo completar el login.';
    }
  }

  private describeOAuthError(error: string, description: string | null): string {
    if (description === 'invalid_scope') {
      return 'Cognito rechazo el login por invalid_scope. Verifica que el App Client tenga habilitado el scope web/transaction:read.';
    }

    return `Cognito rechazo el login: ${description || error}.`;
  }
}
